import { object, string } from 'yup';
import {
  MILEAGE_PLUS_NUMBER_PATTERN,
  normalizeMileagePlusNumber,
} from '@/utils/constants/mileagePlus';

export const mileagePlusVerificationSchema = () =>
  object({
    membershipId: string()
      .trim()
      .required('The field is required')
      .transform((value) => normalizeMileagePlusNumber(value ?? ''))
      .matches(
        MILEAGE_PLUS_NUMBER_PATTERN,
        'Please enter a valid MileagePlus number'
      ),
    surname: string().trim().required('The field is required'),
  });
